export { Tennisball as default } from './Tennisball';
